module.exports = SharedDependencies.MobXReact['@local/application'];